import React from "react";
import { CDN_URL } from "../Helpers"; // Adjust this path if your Helpers file is elsewhere

export default function OneStaff({ data }) {
  // 1. Safe fallbacks so nothing evaluates to the literal string "undefined"
  const staffName = data?.fullName || data?.name || "Staff Member";
  const staffRole = data?.role || data?.position || "Team Member";
  const staffIntro = data?.body || data?.intro || "";

  // 2. Safely construct the image URL or use a backup placeholder
  const staffPhotoUrl = data?.photo 
    ? `${CDN_URL || ''}${data.photo}` 
    : 'https://placehold.co/170x170?text=No+Photo';

  return (
    <div className="p-3 text-center w-100">
      {/* Staff Photo */}
      <div
        className="rounded overflow-hidden mx-auto border"
        style={{
          width: "200px",
          height: "200px",
          backgroundImage: `url(${staffPhotoUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundColor: "#f8fafc"
        }}
      ></div>

      {/* Staff Name */}
      <h6 className="mt-3 mb-1 fw-bold text-dark">{staffName}</h6>

      {/* Position / Faded background */}
      <div
        className="mx-auto mt-2"
        style={{
          background: "#f1f5f9",
          borderRadius: "8px",
          padding: "4px 8px",
          fontSize: "0.85rem",
          color: "#475569",
          maxWidth: "180px",
        }}
      >
        {staffRole}
      </div>

    </div>
  );
}